import React, { useState, useEffect, useRef } from "react";
import Layout from "../../../Components/Layout/layout";
import dashboardclasses from "../../dashboard.module.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import BootstrapTable from "react-bootstrap-table-next";
import ReactPaginate from "react-paginate";
import "../../../App.css";
import { css } from "@emotion/react";
import ScaleLoader from "react-spinners/ScaleLoader";
import { Services } from "../../../Services";
import { toast } from "react-toastify";
import Moment from "react-moment";
import { useNavigate, useSearchParams } from "react-router-dom";
import swal from "sweetalert";

function Products() {
    const Navigate = useNavigate();
    const [tableLoad, setTableLoad] = useState(true);
    const [params, setparams] = useSearchParams();
    let [loading, setLoading] = useState(true);
    const fromDateRef = useRef();
    const toDateRef = useRef();
    const mobileRef = useRef();
    const [Navactive, setNavactive] = useState("1");
    const [mobile, setMobile] = useState(null);
    const [pageCount, setpageCount] = useState(1);
    const [orders, setOrders] = useState([]);
    const [showPaginate, setShowPagiate] = useState(true);
    const [forcePage, setForcePage] = useState(1);

    const token = { Authorization: `token ${sessionStorage.getItem("token")}` };
    const headerstyles = {
        color: "#707275",
        fontWeight: 700,
        fontSize: "0.8rem",
    };
    const override = css`
        display: block;
        margin: 0 auto;
        border-color: red;
    `;

    useEffect(() => {
        if (params.get("page")) {
            getorders(params.get("page"), params.get("tab"));
            setForcePage(Number(params.get("page") - 1));
            setNavactive(params.get("tab"));
        }
        // eslint-disable-next-line
    }, [mobile]);
    const getorders = (page, active) => {
        setTableLoad(true);
        Services.Mobility_Bookings("GET", null, token, active, page, mobile)
            .then((res) => {
                console.log(res);
                setLoading(false);
                // setTabloader(false);
                setTableLoad(false);

                if (res.Status === 1) {
                    setOrders(res.Bookings);
                    setpageCount(res?.Pagination?.totalPages);
                    console.log(res?.Pagination?.totalPages);
                    if (res?.Pagination?.totalPages == 0) {
                        console.log("Inside");
                        setShowPagiate(false);
                    }
                } else if (res.Status === 0) {
                    toast.error(`${res.Message}`, {
                        position: "top-center",
                        autoClose: 1000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    if (res.Message === "Token expired") {
                        Navigate("/");
                    }
                }
            })
            .catch((err) => {
                // alert(err);
                alert("something went wrong please try again");
                console.log(err);
            });
    };

    const Submit = () => {
        setNavactive(params.get("tab"));
        getorders(params.get("page"), params.get("tab"));
        if (params.get("page")) {
            setpageCount(Number(params.get("page")));
            setForcePage(Number(params.get("page") - 1));
        }
    };
    const Idformatter = (cell, cellcontent, index, formatExtraData) => {
        return (
            <div>
                <p className={dashboardclasses["idformatter"]}>{cell}</p>
            </div>
        );
    };

    const priceFormatter = (cell) => {
        //className={dashboardclasses["priceformatter"]}
        return (
            <div className={dashboardclasses["price-wrapper"]}>
                <p>₹ {cell}</p>
            </div>
        );
    };
    const reminderHandler = (driver_id) => {
        swal("Are You sure you want to Remind Driver to End Ride?", {
            icon: "warning",
            className: dashboardclasses["logout-popup"],
            dangerMode: true,
            buttons: {
                cancel: "No",
                catch: {
                    text: "Remind",
                    value: "Delete",
                    className: dashboardclasses[".cancel-delete"],
                },
                defeat: false,
            },
        }).then((value) => {
            switch (value) {
                case "Delete":
                    setLoading(false);

                    Services.remindDriver(
                        "POST",
                        JSON.stringify({
                            driver_id: driver_id,
                        }),
                        token
                    )
                        .then((res) => {
                            if (res.Status === 1) {
                                getorders();
                                setLoading(true);
                                toast.success(`${res.Message}`, {
                                    position: "top-center",
                                    autoClose: 1000,
                                    hideProgressBar: true,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: undefined,
                                });
                            } else if (res.Status === 0) {
                                setLoading(false);

                                toast.error(`${res.Message}`, {
                                    position: "top-center",
                                    autoClose: 1000,
                                    hideProgressBar: true,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: undefined,
                                });
                                if (res.Message === "Token expired") {
                                    Navigate("/");
                                }
                            }
                        })
                        .catch((err) => {
                            setLoading(false);
                            // alert(err);
                            alert("something went wrong please try again");
                            console.log(err);
                        });
                    break;

                // default:
                //     swal("Got away safely!");
            }
        });
    };
    const EndRide = (booking_id) => {
        swal("Are You sure you want to End Ride?", {
            icon: "warning",
            className: dashboardclasses["logout-popup"],
            dangerMode: true,
            buttons: {
                cancel: "No",
                catch: {
                    text: "End ride",
                    value: "Delete",
                    className: dashboardclasses[".cancel-delete"],
                },
                defeat: false,
            },
        }).then((value) => {
            switch (value) {
                case "Delete":
                    setLoading(false);

                    Services.updateBooking(
                        "POST",
                        JSON.stringify({
                            booking_id: booking_id,
                            status: 10,
                        }),
                        token
                    )
                        .then((res) => {
                            if (res.Status === 1) {
                                getorders();
                                setLoading(true);
                                toast.success(`${res.Message}`, {
                                    position: "top-center",
                                    autoClose: 1000,
                                    hideProgressBar: true,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: undefined,
                                });
                            } else if (res.Status === 0) {
                                setLoading(false);

                                toast.error(`${res.Message}`, {
                                    position: "top-center",
                                    autoClose: 1000,
                                    hideProgressBar: true,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: undefined,
                                });
                                if (res.Message === "Token expired") {
                                    Navigate("/");
                                }
                            }
                        })
                        .catch((err) => {
                            setLoading(false);
                            // alert(err);
                            alert("something went wrong please try again");
                            console.log(err);
                        });
                    break;

                // default:
                //     swal("Got away safely!");
            }
        });
    };

    let columns = [
        {
            dataField: "booking_id",
            text: "BOOKING ID",
            sort: false,
            // cell: (row, index) => index + 1,
            formatter: Idformatter,
            headerStyle: (colum, colIndex) => {
                return {
                    ...headerstyles,
                };
            },
        },
        {
            dataField: "user_mobile",
            text: "USER",
            sort: false,
            formatter: (cell, cellContent) => {
                return (
                    <>
                        {cellContent.name},<br />
                        {cell}
                    </>
                );
            },
            // cell: (row, index) => index + 1,
            headerStyle: (colum, colIndex) => {
                return {
                    ...headerstyles,
                };
            },
        },

        {
            dataField: "ADDRESS",
            text: "PICK UP ADDRESS",
            sort: false,
            formatter: (cell, cellContent) => (
                <>
                    {cellContent?.main_pickup_address?.areaName} <br />
                    {cellContent?.main_pickup_address?.buildingName} <br />
                    {cellContent?.main_pickup_address?.city} <br />
                    {cellContent?.main_pickup_address?.pincode}
                </>
            ),
            headerStyle: (colum, colIndex) => {
                return { ...headerstyles };
            },
        },
        {
            dataField: "ADDRESS",
            text: "DROP ADDRESS",
            sort: false,
            formatter: (cell, cellContent) => (
                <>
                    {cellContent?.main_drop_address?.areaName} <br />
                    {cellContent?.main_drop_address?.buildingName} <br />
                    {cellContent?.main_drop_address?.city} <br />
                    {cellContent?.main_drop_address?.pincode}
                </>
            ),
            headerStyle: (colum, colIndex) => {
                return { ...headerstyles };
            },
        },
        {
            dataField: "transport_name",
            text: "TRANSPORT",
            sort: false,
            headerStyle: (colum, colIndex) => {
                return { ...headerstyles };
            },
        },

        {
            dataField: "book_date",
            text: "BOOK DATE",
            sort: false,

            headerStyle: (colum, colIndex) => {
                return { ...headerstyles };
            },
        },
        {
            dataField: "start_time_formatted",
            text: "START TIME",
            sort: false,
            formatter: (cell, cellContent) => cell,
            headerStyle: (colum, colIndex) => {
                return { ...headerstyles };
            },
        },
        {
            dataField: "end_time_formatted",
            text: "END TIME",
            sort: false,

            headerStyle: (colum, colIndex) => {
                return { ...headerstyles };
            },
        },
        {
            dataField: "grand_total",
            text: "RIDE FARE",
            sort: false,
            formatter: priceFormatter,
            headerStyle: (colum, colIndex) => {
                return { ...headerstyles };
            },
        },
        {
            dataField: "payment_method",
            text: "PAYMENT",
            sort: false,
            formatter: (cell) =>
                !cell
                    ? ""
                    : cell == 1
                    ? "CASH"
                    : cell == 2
                    ? "ONLINE"
                    : "WALLET",
            headerStyle: (colum, colIndex) => {
                return { ...headerstyles };
            },
        },
    ];
    if (Navactive == 2) {
        columns = [
            ...columns,
            {
                dataField: "ACTIONS",
                text: "ACTIONS",
                sort: false,
                formatter: (cell, cellContent) => (
                    <div style={{ display: "flex", gap: "1rem" }}>
                        <button
                            style={{
                                padding: "0.5rem",
                                borderRadius: "5px",
                                border: "1px solid #ccc",
                            }}
                            onClick={(E) => {
                                E.stopPropagation();
                                reminderHandler(cellContent.driver_id);
                            }}>
                            Send Reminder{" "}
                        </button>
                        <button
                            style={{
                                padding: "0.5rem",
                                borderRadius: "5px",
                                border: "1px solid #ccc",
                            }}
                            onClick={(E) => {
                                E.stopPropagation();
                                EndRide(cellContent.booking_id);
                            }}>
                            End Ride{" "}
                        </button>
                    </div>
                ),
                headerStyle: (colum, colIndex) => {
                    return { ...headerstyles, width: "15rem" };
                },
            },
        ];
    }
    const defaultSorted = [
        {
            dataField: "name",
            order: "desc",
        },
    ];
    const handlePageChange = (selectedObject) => {
        console.log(selectedObject);
        setForcePage(selectedObject.selected);
        window.scrollTo({ top: 10, behavior: "instant" });
        // Navigate(`/purchaseorder?page=${selectedObject.selected + 1}`);
        setparams({ page: selectedObject.selected + 1, tab: Navactive });
        getorders(selectedObject.selected + 1, Navactive);
        setTableLoad(true);
    };

    const navactivehandler = (e) => {
        let status = e.currentTarget.getAttribute("id");
        setNavactive(status);

        setparams({ page: 1, tab: status });
        getorders(1, status);
    };

    const emptyDataMessage = () => {
        return "No Data to Display";
    };
    const tableRowEvents = {
        onClick: (e, row, rowIndex) => {
            e.preventDefault();
            Navigate(`/booking-Order-details/${row.booking_id}/${row.type}`);
        },
    };
    const SearchData = () => {
        setTableLoad(true);
        setparams({ page: 1, tab: Navactive });
        setForcePage(1);
        console.log(fromDateRef.current.value, toDateRef.current.value);
        let body = {};
        if (mobileRef.current.value) {
            body = { mobile: mobileRef.current.value };
        }
        let from = fromDateRef.current.value;
        let to = toDateRef.current.value;
        if (from && to) {
            body = { ...body, to, from };
        } else if (!from && to) {
            body = { ...body, to, from: to };
        } else if (from && !to) {
            body = { ...body, to: from, from };
        }
        console.log(body);
        setMobile(body);
    };

    const DownloadData = () => {
        let body = {};
        if (mobileRef.current.value) {
            body = { mobile: mobileRef.current.value };
        }
        let from = fromDateRef.current.value;
        let to = toDateRef.current.value;
        if (from && to) {
            body = { ...body, to, from };
        } else if (!from && to) {
            body = { ...body, to, from: to };
        } else if (from && !to) {
            body = { ...body, to: from, from };
        }
        setTableLoad(true);
        Services.Download_Bookings("GET", null, token, Navactive, body)
            .then((res) => {
                setLoading(false);
                setTableLoad(false);
                const url = window.URL.createObjectURL(res);
                const a = document.createElement("a");
                a.href = url;
                a.download = "report.xlsx";
                document.body.appendChild(a);
                a.click();
                a.remove();
                window.URL.revokeObjectURL(url);
            })
            .catch((err) => {
                // alert(err);
                alert("something went wrong please try again");
                console.log(err);
            });
    };
    const remindDriver = () => {};
    return (
        <>
            <Layout Active={"mobility_Bookings"}>
                <div className={dashboardclasses["dashboard-rightside"]}>
                    <div className={dashboardclasses.CategoryWrapper}>
                        <h3>Bookings</h3>
                        {loading ? (
                            <div className={dashboardclasses["loader"]}>
                                <ScaleLoader
                                    color={"black"}
                                    loading={true}
                                    css={override}
                                    size={150}
                                />
                            </div>
                        ) : (
                            <>
                                <div
                                    className={
                                        dashboardclasses["category-form"]
                                    }
                                    style={{
                                        gridTemplateColumns:
                                            "1fr 0.5fr 0.5fr 0.5fr 0.5fr",
                                    }}>
                                    <input
                                        type={"text"}
                                        placeholder="search by Mobile number"
                                        ref={mobileRef}
                                    />
                                    <input type="date" ref={fromDateRef} />
                                    <input type="date" ref={toDateRef} />
                                    <button onClick={SearchData} type="submit">
                                        Search
                                    </button>
                                    <button
                                        onClick={DownloadData}
                                        type="button">
                                        Export
                                    </button>
                                </div>
                                <div
                                    className={
                                        dashboardclasses["orders-navbar"]
                                    }>
                                    <button
                                        id="1"
                                        className={
                                            Navactive == "1" &&
                                            dashboardclasses["order-active"]
                                        }
                                        onClick={navactivehandler}>
                                        Pending
                                    </button>
                                    <button
                                        id="2"
                                        className={
                                            Navactive == "2" &&
                                            dashboardclasses["order-active"]
                                        }
                                        onClick={navactivehandler}>
                                        Ongoing
                                    </button>
                                    <button
                                        id="3"
                                        className={
                                            Navactive == "3" &&
                                            dashboardclasses["order-active"]
                                        }
                                        onClick={navactivehandler}>
                                        Completed
                                    </button>
                                    <button
                                        id="4"
                                        className={
                                            Navactive == "4" &&
                                            dashboardclasses["order-active"]
                                        }
                                        onClick={navactivehandler}>
                                        Cancelled
                                    </button>
                                    <button
                                        id="5"
                                        className={
                                            Navactive == "5" &&
                                            dashboardclasses["order-active"]
                                        }
                                        onClick={navactivehandler}>
                                        Expired
                                    </button>
                                </div>

                                {tableLoad ? (
                                    <div className={dashboardclasses["loader"]}>
                                        <ScaleLoader
                                            color={"black"}
                                            loading={true}
                                            css={override}
                                            size={150}
                                        />
                                    </div>
                                ) : (
                                    <div className="category-table">
                                        <BootstrapTable
                                            bootstrap4
                                            keyField="id"
                                            data={orders}
                                            columns={columns}
                                            defaultSorted={defaultSorted}
                                            // pagination={pagination}
                                            wrapperClasses="table-responsive"
                                            noDataIndication={emptyDataMessage}
                                            rowEvents={tableRowEvents}
                                        />
                                        {showPaginate && (
                                            <div
                                                style={{
                                                    justifySelf: "right",
                                                }}>
                                                <ReactPaginate
                                                    pageCount={pageCount}
                                                    marginPagesDisplayed={2}
                                                    onPageChange={
                                                        handlePageChange
                                                    }
                                                    forcePage={forcePage}
                                                    breakClassName={"page-item"}
                                                    breakLinkClassName={
                                                        "page-link"
                                                    }
                                                    containerClassName={
                                                        "pagination"
                                                    }
                                                    pageClassName={"page-item"}
                                                    pageLinkClassName={
                                                        "page-link"
                                                    }
                                                    previousClassName={
                                                        "page-item"
                                                    }
                                                    previousLinkClassName={
                                                        "page-link"
                                                    }
                                                    nextClassName={"page-item"}
                                                    nextLinkClassName={
                                                        "page-link"
                                                    }
                                                    activeClassName={"active"}
                                                />
                                            </div>
                                        )}
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                </div>
            </Layout>
        </>
    );
}

export default Products;
